import React from 'react';
import { Pagination, List } from 'react-admin';

const CustomPagination = props => <Pagination rowsPerPageOptions={[25, 50, 75]} {...props} />;

export default CustomPagination;
